import { stringify, parse } from 'query-string';

export const objToQuery = (obj: Record<string, any>) =>
  stringify(obj, { skipNull: true, skipEmptyString: true });

export const queryToObj = (query: string) => parse(query);
